import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.scss']
})
export class PressComponent implements OnInit {
  title = 'Benutech in the news';

  newsData: any[] = new Array();
  counter: number;

  private data = [
    {
      logo: 'lending-brand',
      title: 'AWARDS',
      subTitle: 'Benutech Named 2025 Lending Tech Titan',
      summary: 'The award honors tech companies whose solutions provide a clear and tangible benefit to mortgage lenders.',
      date: 'July 28, 2025',
      linkText: 'Read article',
      linkUrl: 'https://mymortgagemindset.com/'
    },
    {
      logo: 'title-toolbox-brand',
      title: 'PRESS RELEASES',
      subTitle: 'Benutech’s Title Toolbox Becomes the Leading Platform Among Title Agencies',
      summary: 'Benutech is now the leading tech provider for title agencies thanks to the widespread adoption of Title Toolbox.',
      date: 'March 12, 2025',
      linkText: 'Read article',
      linkUrl: ''
    },
    {
      logo: 'benutech-brand',
      title: 'PRESS RELEASES',
      subTitle: 'Benutech Establishes One of Nation’s Largest Repositories of Real-Time Property Data',
      summary: 'Through its flagship products, Benutech offers clients the ability to leverage its database to grow their client lists and enhance workflow efficiencies.',
      date: 'May 18, 2021',
      linkText: 'Read article',
      linkUrl: ''
    },
    {
      logo: 'title-toolbox-brand',
      title: 'PRESS RELEASES',
      subTitle: 'Benutech`s Title Toolbox Launches New Marketing Property Profile Automating Possible Next Listings',
      summary: 'Title Toolbox`s upgraded features to the New Marketing Property Profile provide title companies with new customization options.',
      date: 'May 18, 2020',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12822820-benutechs-title-toolbox-launches-new-marketing-property-profile-automating-possible-next-listings.html'
    },
    {
      logo: 'benutech-brand',
      title: 'PRESS RELEASES',
      subTitle: 'Benutech named to Inc. 5000 List of Fastest-Growing Companies',
      summary: '(For reference: https://www.inc.com/profile/benutech) Benutech ranked No. 3232 on Inc. Magazine’s 37th annual Inc. 5000 list of the nation’s fastest-growing private companies.',
      date: 'August 15, 2018',
      linkText: 'Read article',
      linkUrl: ''
    },
    {
      logo: 'rebo-brand',
      title: 'Press releases',
      subTitle: 'Benutech Inc., Offers ReboConnect, Affordable Data Available to 3rd Party Real Estate Tech Vendors',
      summary: 'ReboConnect `Scholarship Program` eases the struggle for affordable real estate data needed by today`s RETech Entrepreneurs.',
      date: 'March 5, 2018',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12694670-benutech-inc-offers-reboconnect-affordable-data-available-to-3rd-party-real-estate-tech-vendors.html'
    },
    {
      logo: 'housing-brand',
      title: 'Press releases',
      subTitle: 'HousingWire Selects Benutech for the Fifth Consecutive Year As 2017 Top 100 Real Estate Tech List',
      summary: 'Benutech is once again named to HousingWire’s Tech100 List of leading tech providers for the housing industry.',
      date: 'March 1, 2017',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12623543-housingwire-selects-benutech-for-the-fifth-consecutive-year-as-2017-top-100-real-estate-tech-list.html'
    },
    {
      logo: 'miami-brand',
      title: 'Press releases',
      subTitle: 'Miami Association of REALTORS® awards Benutech’s ReboGateway/Tract Utility as 2015 Product of the Year',
      summary: 'ReboGateway/Tract Utility Tool proves to be an award winning valuable member benefit for' +
      ' the Miami Association of REALTORS®',
      date: 'March 7, 2016',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12539573-miami-association-of-realtors-awards-benutechsrebogatewaytract-utility-product-of-the-year.html'
    },{
      logo: 'housing-brand',
      title: 'Press releases',
      subTitle: 'HousingWire Selects Benutech As 2016 Top 100 Real Estate Tech List For The Fourth Consecutive Year!',
      summary: 'Benutech, creator of lead generation software ReboGateway, is again recognized in ' +
      ' HousingWire’s annual leading technology innovators list',
      date: 'March, 07, 2016',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12539477-housingwire-selects-benutech-as-2016-top-100-real-estate-tech-list-for-the-fourth-consecutive-year.html'
    },{
      logo: 'rebo-brand',
      title: 'Press releases',
      subTitle: '2016 Brings New Innovative Data Leads to ReboGateway',
      summary: 'Costa Mesa, CA – January 12, 2016 – Benutech, Inc., creator of ReboGateway, a lead generation software solution for Real Estate professionals, announces they have added 4 new innovative le” for “Benutech has added four new innovative lead types to the ReboGateway software.',
      date: 'Jan. 13, 2016',
      linkText: 'Read article',
      linkUrl: 'https://www.prlog.org/12524634-2016-brings-new-innovative-data-leads-to-rebogateway.html'
    }
  ];

  constructor() {
    this.counter = 0;
    this.getData();
  }

  getData(){
    let index = this.counter += 10;
    this.newsData = this.data.slice(0, index >= this.data.length ? undefined : index);
    //index >= this.data.length
  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/press/press.component.ts